/* Pilly Labs banner-click attribution. Deliberately collects no customer data. */
(function (root) {
  'use strict';
  const KEY = 'mbk_cid';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  let attemptedCid = null;

  function bannerClickId(href) {
    try {
      const origin = root.location && root.location.origin;
      if (!origin) return null;
      const target = new URL(String(href), origin);
      if (target.origin !== origin) return null;
      const value = target.searchParams.get(KEY);
      return value && UUID.test(value) ? value.toLowerCase() : null;
    } catch { return null; }
  }

  function analyticsConsent() {
    try { return root.plHasConsent && root.plHasConsent('analytics') === true; } catch { return false; }
  }

  async function persistBannerClickId({ href = root.location && root.location.href, fetchImpl = root.fetch } = {}) {
    let writeAttempted = false;
    const cid = bannerClickId(href);
    if (!cid || !analyticsConsent() || typeof fetchImpl !== 'function') {
      return { applied: false, reason: !cid ? 'invalid_or_missing_cid' : 'consent_or_transport_unavailable' };
    }
    try {
      const cartResponse = await fetchImpl('/cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } });
      if (!cartResponse || !cartResponse.ok) return { applied: false, reason: 'cart_unavailable' };
      const cart = await cartResponse.json();
      const existing = cart && cart.attributes && cart.attributes[KEY];
      if (existing && existing !== cid) return { applied: false, reason: 'existing_attribution_preserved' };
      if (existing === cid) return { applied: false, reason: 'already_present' };
      // Consent may have changed while the cart was read. Do not write after revocation.
      if (!analyticsConsent()) return { applied: false, reason: 'consent_revoked_before_write' };
      writeAttempted = true;
      const update = await fetchImpl('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ attributes: { [KEY]: cid } })
      });
      if (!update || !update.ok) return { applied: false, reason: 'cart_update_rejected' };
      const updated = await update.json();
      if (!updated || !updated.attributes || updated.attributes[KEY] !== cid) return { applied: false, reason: 'cart_update_unverified' };
      return { applied: true, cid };
    } catch { return { applied: false, reason: writeAttempted ? 'cart_write_transport_unknown' : 'cart_transport_failed' }; }
  }

  function runWhenEligible() {
    const cid = bannerClickId(root.location && root.location.href);
    if (!cid || !analyticsConsent() || attemptedCid === cid) return;
    attemptedCid = cid;
    Promise.resolve(persistBannerClickId()).then(function (result) {
      // No write was attempted for these pre-write failures, so a later
      // consent grant or transient cart read recovery can make one new try.
      if (result && ['cart_unavailable', 'consent_revoked_before_write', 'cart_transport_failed'].includes(result.reason)) attemptedCid = null;
    }).catch(function () {});
  }

  function bootstrap() {
    if (!root.document || !root.addEventListener) return;
    root.addEventListener('pilly:consent-ready', runWhenEligible);
    // The consent runtime always receives this Shopify event, including when
    // pixels already started and therefore no new pilly:consent-ready fires.
    root.document.addEventListener('visitorConsentCollected', runWhenEligible);
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', runWhenEligible, { once: true });
    else runWhenEligible();
  }

  const api = Object.freeze({ bannerClickId, persistBannerClickId, bootstrap });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PillyBannerClickAttribution = api;
  bootstrap();
}(typeof window === 'undefined' ? globalThis : window));
